module.exports = __webpack_public_path__ + "img/health_worker.243a9f9d.svg";